module.exports = __webpack_public_path__ + "static/media/default.3e0fa88e.svg";